import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { X } from 'lucide-react';
import { SessionType } from '@/api/sessionApi';

interface DonationModalProps {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string | null;
  sessionType: SessionType;
}

export const DonationModal = ({ isOpen, onClose, sessionId, sessionType }: DonationModalProps) => {
  const getStripeLink = () => {
    switch (sessionType) {
      case 'stem':
        return 'https://buy.stripe.com/4gM6oB3InbGd1PB2ZJfAc05';
      case 'acapella':
        return 'https://buy.stripe.com/bJe8wJ1Af11z0LxasbfAc06';
      case 'drum':
        return 'https://buy.stripe.com/7sYcMZdiXh0x79VgQzfAc07';
      default:
        return '';
    }
  };

  const handleDonate = () => {
    // PostHog tracking disabled
    // if (window.posthog) {
    //   window.posthog.capture('Donation CTA Clicked', {
    //     session_id: sessionId,
    //     session_type: sessionType,
    //     amount: 1,
    //   });
    // }
    
    const stripeLink = getStripeLink();
    if (stripeLink) {
      window.open(stripeLink, '_blank');
    }
    
    onClose();
  };

  const handleMaybeLater = () => {
    // PostHog tracking disabled
    // if (window.posthog) {
    //   window.posthog.capture('Donation Modal Dismissed', {
    //     session_id: sessionId,
    //     session_type: sessionType,
    //   });
    // }
    
    onClose();
  };

  // PostHog tracking disabled
  // if (isOpen && window.posthog && sessionId) {
  //   window.posthog.capture('Donation Modal Shown', {
  //     session_id: sessionId,
  //     session_type: sessionType,
  //   });
  // }

  return (
    <TooltipProvider delayDuration={0}>
      <Dialog open={isOpen} onOpenChange={(open) => !open && handleMaybeLater()}>
        <DialogContent className="sm:max-w-[500px] bg-background border-border [&>button]:hidden">
          {/* Custom close button with tooltip */}
          <Tooltip>
            <TooltipTrigger asChild>
              <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
                <X className="h-4 w-4" />
                <span className="sr-only">Close</span>
              </DialogClose>
            </TooltipTrigger>
            <TooltipContent>
              <p>You really want girl to cry, eh?</p>
            </TooltipContent>
          </Tooltip>

          <div className="relative w-full max-w-[200px] mx-auto rounded-lg overflow-hidden mb-4">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              className="w-full h-auto"
              aria-label="Developer crying video"
            >
              <source src="/videos/donation-video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold">
              Stem splitting for free makes girl cry.
            </DialogTitle>
            <DialogDescription className="text-center text-lg pt-2">
              Support server costs – and girl will cry less but still some.
            </DialogDescription>
          </DialogHeader>
          
          <div className="flex flex-col gap-3 w-full py-4">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="default" 
                  className="bg-[#3B82F6] hover:bg-[#60A5FA] text-white w-full"
                  onClick={handleDonate}
                >
                  Donate $1
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>You have a good heart.</p>
              </TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="outline" 
                  className="w-full"
                  onClick={handleMaybeLater}
                >
                  Keep girl crying
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>So many tears</p>
              </TooltipContent>
            </Tooltip>
          </div>
        </DialogContent>
      </Dialog>
    </TooltipProvider>
  );
};
